import React from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { customStyles, setImage } from '../../helper';
import noImage from '../../../assets/images/no-image.png';

export function HeadingSetting({ obj, onChange, handleImageUpload, handleHeadingStyle }) {
  const { t } = useTranslation('common');
  const subHeadingOptions = [
    { label: 'H1', value: 'h1' },
    { label: 'H2', value: 'h2' },
  ];

  const handleImageError = (event) => {
    event.target.src = noImage;
  };

  return (
    <>
      <div className="d-flex align-items-center">
        <p className="custom-radio">
          <input
            type="radio"
            id="iconHeading"
            value="iconHeading"
            onChange={(e) => onChange(e.target.value, 'iconHeading')}
            name="heading"
            checked={obj?.iconHeading}
          />
          <label className="text-bold text-black" htmlFor="iconHeading">
            {t('DPP.CONTROL.HEADING.ICON_HEADING')}
          </label>
        </p>
        <p className="custom-radio ml-4">
          <input
            type="radio"
            id="onlyHeading"
            value="onlyHeading"
            onChange={(e) => onChange(e.target.value, 'iconHeading')}
            name="heading"
            checked={!obj?.iconHeading}
          />
          <label className="text-bold text-black" htmlFor="onlyHeading">
            {' '}
            {t('DPP.CONTROL.HEADING.ONLY_HEADING')}
          </label>
        </p>
      </div>
      {obj?.iconHeading && (
        <div className="heading-icon-container mb-3">
          <figure>
            <img src={obj?.iconPath ? setImage(obj?.iconPath) : noImage} alt="" onError={handleImageError} />
          </figure>
          <button type="button" aria-label="Upload" onClick={() => handleImageUpload('heading', '')} className="btn p-0 px-1 d-inline-flex">
            <i className="icon icon-Upload-1 f-20" />
          </button>
        </div>
      )}
      <div className="common-input-control">
        <p className="field-name">
          {t('DPP.CONTROL.HEADING.HEADING_TITLE')}
          <span className="asterisk">*</span>
        </p>
        <input
          type="text"
          className="form-control"
          value={obj?.value}
          placeholder={t('DPP.ENTER_TEXT')}
          onChange={(e) => onChange(e.target.value, 'value')}
          // onBlur={(e) => trimLabel(e.target.value, "Placeholder")}
          maxLength="40"
        />
      </div>
      <div className="common-react-select mb-0">
        <p className="field-name">{t('DPP.CONTROL.HEADING.HEADING_TYPE')}</p>

        <Select
          placeholder={t('DPP.CONTROL.HEADING.SELECT_HEADING_TYPE')}
          options={subHeadingOptions}
          styles={customStyles}
          className="common-select"
          classNamePrefix="common-select"
          getOptionLabel={({ label }) => `${label}`}
          getOptionValue={({ value }) => `${value}`}
          value={obj?.headingType}
          onChange={(selected) => handleHeadingStyle(selected)}
        />
      </div>
    </>
  );
}

export default HeadingSetting;
